import React, { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import styled from 'styled-components';
import moment from 'moment-timezone';
import StoreController, { CurrentStoreContext, StoreType } from '../../controller/StoreController';
import OrderController, { SalesType, SalesListType } from '../../controller/OrderController';
import ConfirmModal from '../../components/modal/ConfirmModal';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ko from 'date-fns/locale/ko';

interface tabType {
  id: number;
  tab: string;
}
const dateTabContent = [
  {
    id: 0,
    tab: '오늘',
  },
  {
    id: 1,
    tab: '어제',
  },
  {
    id: 2,
    tab: '최근 7일',
  },
  {
    id: 3,
    tab: '최근 30일',
  },
];
const useTabs = (initialTabs: tabType[]) => {
  const [contentIndex, setContentIndex] = useState<number>(0);

  const activateTab = (index: number) => {
    setContentIndex(index);
  };
  return {
    contentItem: initialTabs[contentIndex],
    contentChange: activateTab,
    activeIndex: contentIndex,
  };
};

const HotelInfo = () => {
  const nowDate = new Date();
  nowDate.setHours(0, 0, 0, 0);
  const currentDayOfWeek = nowDate.getDay();
  // 어제
  const yesterdayDate = new Date(nowDate);
  yesterdayDate.setDate(nowDate.getDate() - 1);

  // 최근 7일
  const weekStartDate = new Date(nowDate);
  weekStartDate.setDate(nowDate.getDate() - 7);
  const weekEndDate = new Date(nowDate);
  const { currentStore } = useOutletContext<CurrentStoreContext>();
  const [startDate, setStartDate] = useState<Date | null>(nowDate);
  const [visibleConfirm, setVisibleConfirm] = useState<boolean>(false);
  const [endDate, setEndDate] = useState<Date | null>(nowDate);
  const [deliverySalesList, setDeliverySalesList] = useState<any>([]);
  const [confirmData, setConfirmData] = useState<any>(null);
  const monthStartDate = new Date(nowDate);
  monthStartDate.setDate(nowDate.getDate() - 30);
  const monthEndDate = new Date(nowDate);
  const { contentItem: dateContentItem, contentChange: dateContentChange } =
    useTabs(dateTabContent);
  const tabClick = (index: number) => {
    dateContentChange(index);
    if (index === 0) {
      setStartDate(nowDate);
      setEndDate(nowDate);
    } else if (index === 1) {
      setStartDate(yesterdayDate);
      setEndDate(yesterdayDate);
    } else if (index === 2) {
      setStartDate(weekStartDate);
      setEndDate(weekEndDate);
    } else if (index === 3) {
      setStartDate(monthStartDate);
      setEndDate(monthEndDate);
    }
  };
  const handleDateChange = (dates: [Date | null, Date | null]) => {
    setStartDate(dates[0]);
    setEndDate(dates[1]);
  };

  // 주문 상태
  const getStatusComment = (status: number) => {
    if (status === 0) return '주문대기';
    else if (status === 1) return '준비중';
    else if (status === 2) return '조리완료';
    else if (status === 3) return '서빙완료';
    else if (status === 4) return '주문취소';
    else if (status === 5) return '주문완료';
    else if (status === 6) return '배달시작';
    else if (status === 7) return '배달완료';
  };
  // 국적
  const getStatusCountry = (status: number) => {
    if (status === 0)
      return <img src={`${process.env.PUBLIC_URL}/svg/flag_korea.svg`} alt="한국" />;
    else if (status === 1)
      return <img src={`${process.env.PUBLIC_URL}/svg/flag_usa.svg`} alt="미국" />;
    else if (status === 2)
      return <img src={`${process.env.PUBLIC_URL}/svg/flag_china.svg`} alt="중국" />;
    else if (status === 3)
      return <img src={`${process.env.PUBLIC_URL}/svg/flag_japan.svg`} alt="일본" />;
    else if (status === 4)
      return <img src={`${process.env.PUBLIC_URL}/svg/flag_thailand.svg`} alt="태국" />;
  };
  // 강제 배달 완료
  const completeDelivery = async (data: any) => {
    setConfirmData(data);
    setVisibleConfirm(true);
  };

  // 주문 리스트
  const RenderHistoryList = () => {
    return (
      <div className="historyList">
        {deliverySalesList.length > 0 ? (
          deliverySalesList.map((data: SalesListType, index: number) => {
            return (
              <div key={index}>
                <div className="historyItem">
                  <div className="row">
                    <div className={`itemBadge status ${data.order_status === 4 && 'cancel'}`}>
                      {getStatusComment(data.order_status)}
                    </div>
                    <div className="itemBadge">
                      <h5 className="title">객실: </h5>
                      {data.delivery_address_detail}
                    </div>
                    <div className="itemBadge">
                      <h5 className="title">주문시간: </h5>
                      {moment(data.ordered_at).format('yyyy.MM.DD HH:mm:ss')}
                    </div>
                    <div className="itemBadge">
                      <h5 className="title">접수번호(billNumber): </h5>
                      {data.bill_number}
                    </div>
                    {data.order_status === 4 && (
                      <>
                        <div className="itemBadge cancelText">
                          <h5 className="title">주문취소시간: </h5>
                          {moment(data.cancelled_at).format('yyyy.MM.DD HH:mm:ss')}
                        </div>
                        <div className="itemBadge cancelText">
                          <h5 className="title">주문취소사유: </h5>
                          {data.cancel_description}
                        </div>
                      </>
                    )}
                  </div>
                  <div className="row">
                    <div className="itemBadge">
                      <h5 className="title">결제금액: </h5>
                      {data.total_amount_incl.toLocaleString()}원
                    </div>
                    <div className="itemBadge">
                      <h5 className="title">주문금액: </h5>
                      {data.total_amount_org.toLocaleString()}원
                      <h5 className="title gap">
                        할인금액:
                        {(data.com_discount_amount + data.store_discount_amount).toLocaleString()}원
                      </h5>
                    </div>
                    <div className="itemBadge">
                      <h5 className="title">배달팁: </h5>
                      {data.delivery_tip.toLocaleString()}원
                    </div>
                    <div className="itemBadge">
                      <h5 className="title">객실관리팁: </h5>
                      {data.room_tip.toLocaleString()}원
                    </div>
                  </div>
                  <div className="row dotted">
                    <div className="itemBadge">
                      <h5 className="title">매장명: </h5>
                      {data.store_name}
                    </div>
                    <div className="itemBadge">
                      <h5 className="title">요청사항: </h5>
                      {data.inquiry === '' ? ' -' : data.inquiry}
                    </div>
                    <div className="itemBadge flag">
                      <h5 className="title">언어</h5>
                      {getStatusCountry(data.lang)}
                    </div>
                  </div>
                  <div className="row">
                    <div className="itemBadge info">
                      주문 확인:
                      {data.confirmed_at === null
                        ? '-'
                        : moment(data.confirmed_at).format('HH:mm:ss')}
                    </div>
                    <div className="itemBadge info">
                      주문 준비 완료:
                      {data.prepared_at === null
                        ? '-'
                        : moment(data.prepared_at).format('HH:mm:ss')}
                    </div>
                    <div className="itemBadge info">
                      배달도착 예상시간:
                      {data.delivery_expected_at === null
                        ? '-'
                        : moment(data.delivery_expected_at).format('HH:mm:ss')}
                    </div>
                    <div className="itemBadge info">
                      배달 시작:
                      {data.delivery_started_at === null
                        ? '-'
                        : moment(data.delivery_started_at).format('HH:mm:ss')}
                    </div>
                    <div className="itemBadge info">
                      배달 완료:
                      {data.delivery_completed_at === null
                        ? '-'
                        : moment(data.delivery_completed_at).format('HH:mm:ss')}
                    </div>
                    {(data.order_status === 2 || data.order_status === 6) && (
                      <div>
                        <button
                          onClick={() => {
                            completeDelivery(data);
                          }}
                          className="manualDeliveryBtn">
                          배달완료 관리
                        </button>
                      </div>
                    )}
                    {data.delivery_score && (
                      <div className="itemBadge info score">
                        배달기사 리뷰:{data.delivery_score}
                      </div>
                    )}
                    {data.food_score && (
                      <div className="itemBadge info score"> 음식 리뷰:{data.food_score}</div>
                    )}
                    {data.content && (
                      <div className="itemBadge info score"> 리뷰 상세 내용:{data.content}</div>
                    )}
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <h2 className="noneList">주문내역이 없습니다.</h2>
        )}
      </div>
    );
  };
  const getSalesList = async () => {
    try {
      const oData = {
        start_date: moment(startDate).format('YYYY-MM-DD'),
        end_date: moment(endDate).format('YYYY-MM-DD'),
        store_id: currentStore.value,
      };

      const response = await OrderController.getSalesList(oData);

      if (response.data.ok) {
        setDeliverySalesList(response.data.data.list);
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };
  const getCompleteOrderHotelAdmin = async (data: any) => {
    try {
      const oData = {
        order_id: data.order_id,
        order_seq: data.order_seq,
      };

      const response = await OrderController.completeOrderHotelAdmin(oData);

      if (response.data.ok) {
        setVisibleConfirm(false);
        getSalesList();
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };
  React.useEffect(() => {
    getSalesList();
  }, [startDate, endDate]);

  return (
    <Style>
      <div className="contentContainer">
        <div className="tabWrap">
          {dateTabContent.map((section, index) => (
            <button
              key={'dateButtons-' + index.toString()}
              onClick={() => tabClick(index)}
              className={dateContentItem.id === section.id ? 'tab active' : 'tab'}>
              <h2>{section.tab}</h2>
            </button>
          ))}
        </div>
        <RenderHistoryList />
      </div>
      <ConfirmModal
        isOpen={visibleConfirm}
        title={`객실에서 배달 완료 알람이 울리며\n배달 완료 처리를 복구할 수 없습니다.`}
        onCancelText="취소"
        onConfirmText="배달완료"
        onCancel={() => setVisibleConfirm(false)}
        onConfirm={() => getCompleteOrderHotelAdmin(confirmData)}
      />
    </Style>
  );
};

export default HotelInfo;

const Style = styled.div`
  /* tabWrap */
  .tabWrap {
    display: flex;
    align-items: center;
    gap: 10px;

    .tab {
      padding: 8px 26px;
      border: 1px solid #cecece;
      border-radius: 5px;

      h2 {
        font-size: 16px;
        font-weight: 600;
        line-height: 19px;
        color: #979797;
      }
    }
    .tab.active {
      background: #4dd2ae;
      border-color: #4dd2ae;
      h2 {
        color: #fff;
      }
    }
  }

  /* contentContainer */
  .contentContainer {
    padding: 24px;
  }
  .historyList {
    padding: 10px 0;
    display: flex;
    flex-direction: column;
    gap: 4px;

    .historyItem {
      display: flex;
      flex-direction: column;
      gap: 4px;
      border-bottom: 1px solid #cecece;
      padding: 8px 0;

      .row {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 4px;
      }
      .row.dotted {
        padding-bottom: 3px;
        border-bottom: 1px dotted #d9d9d9;
      }
      .itemBadge {
        display: flex;
        padding: 6px 8px;
        align-items: center;
        font-size: 14px;
        line-height: 16px;
        font-weight: 400;
        color: #333333;
        border-radius: 3px;
        background: #ffffff;
        border: 1px solid #cecece;
        white-space: nowrap;

        h5.title {
          font-size: 14px;
          line-height: 16px;
          font-weight: 400;
          padding: 0 4px 0 0;
          color: #aaaaaa;
        }
        h5.gap {
          padding-left: 8px;
        }
      }
      .itemBadge.status {
        background: #4dd2ae;
        border: 1px solid #4dd2ae;
        color: #ffffff;
      }
      .itemBadge.cancel {
        background: red;
        border: 1px solid red;
      }
      .itemBadge.cancelText {
        color: red;
      }
      .itemBadge.info {
        padding: 3px 6px;
        border: 1px solid #d9d9d9;
        background: #d9d9d9;
      }
      .itemBadge.info.score {
        background: #eee;
      }
      .itemBadge.detailButton {
        padding: 6px 12px;
        background: linear-gradient(180deg, #648fe7 3.06%, #0d2a6c 97.5%);
        border-radius: 4px;
        box-shadow: 4px 4px 4px 0px #0000001a;
        border: 3px solid linear-gradient(281.11deg, #132756 1.98%, #ccddff 97.75%);
        color: #fff;
        font-weight: 600;
        cursor: pointer;
      }
    }
    .historyItem.log {
      background: rgba(0, 0, 0, 0.05);
      padding: 4px 8px;

      .itemBadge {
        padding: 4px 6px;
        background: #fff;
        font-size: 14px;
      }
      .itemBadge.title {
        background: yellow;
        color: #000;
      }
    }
  }
  .manualDeliveryBtn {
    background:#000;
    color:#fff;
    padding: 4px 6px;
    border-radius: 4px;
    font-size: 14px;
  }
  .noneList {
    font-size: 16px;
    font-weight: 500;
    text-align: center;
    margin: 100px 0;
  }

  img {
    width: 20px;
  }

  @media (max-width: 600px) {
    .tabWrap {
      gap: 6px;
      .tab {
        flex: 1;
        padding: 6px 10px;
        h2 {
          white-space: nowrap;
          font-size: 14px;
        }
      }
    }
  }
`;
